import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class SolicitudArrendamientoService extends DefaultService {
  
  constructor() {
    super('SolicitudArrendamiento');
  }

  getall(id: string, filters: any): Promise<any>{
    let query = new URLSearchParams(filters).toString();
    return API.get(`solicitudArrendamiento/${id}` + '?' + query);
  }

  getLocacion(id:string){
    return API.get(`solicitudArrendamiento/getLocacion/${id}`);
  }

  getGiro(){
    return API.get(`solicitudArrendamiento/cat/getgiro`);
  }

  validarSolicitud(id: any): Promise<any> {
    return API.post(`solicitudArrendamiento/validarSolicitud/${id}`);
  }

  create(data: any): Promise<any> {
    return API.post(`solicitudArrendamiento/guardarcontrato`, data);
  }

  update(data: any): Promise<any> {
    return API.post(`solicitudArrendamiento/actualizarcontrato`, data);
  }
  validarContrato(id: any): Promise<any> {
    return API.post(`solicitudArrendamiento/validarContrato/${id}`);
  }
  subirArchivoSolidPago(id: any, data: any): Promise<any> {
    return API.post(`solicitudArrendamiento/archivo/solidPago/${id}`, data);
}
}

export default new SolicitudArrendamientoService;